// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2GR25","detailsBorder":"styles_detailsBorder__1uGYz"};